<app-spinner *ngIf="isLoading" placement="full-page" size="34px"></app-spinner>

<app-page-wrapper *ngIf="!isLoading && userProfile" scrollable="true">

  <div class="profile-wrap">

  <div class="profile-header">
    <div class="header-text">Profile</div>
  </div>

  <div class="profile-card">

    <div class="header-row">

      <div class="left">
        <div class="avatar">
          <input class="avatar-file" type="file" (change)="onFileSelected($event)" accept="image/*" *ngIf="!uploading">
          <img [src]="profileImgURL" alt="Profile Photo" *ngIf="profileImgURL && !uploading">
          <app-svg-loader *ngIf="!profileImgURL && !uploading" height="18px"
            url="assets/svg/user-solid.svg"></app-svg-loader>
          <app-spinner *ngIf="uploading" variant="btn-spinner"></app-spinner>
        </div>
        <div class="details">
          <div class="user-name">
            {{userProfile.firstName}} {{userProfile.lastName}}
          </div>
          <div class="email" style="font-weight: 300; font-size: 13px; margin-top: 4px">
            {{userProfile.email}}
          </div>
        </div>
      </div>

      <!-- // TODO: ADDRESS -->
      <!-- <div class="right">
        <div class="status-badge">
          Trial Active
        </div>
      </div> -->

    </div>

    <app-alert-message *ngIf="uploadError" mb="24px" type="error">
      Having trouble updating your profile image. Try again...
    </app-alert-message>

    <form class="info-form">
      <div class="row">
        <app-base-input id="firstName" name="firstName" placeholder="First Name" [(ngModel)]="firstName" isFluid="true"
          mb="14px" (ngModelChange)="checkFormChanges()"></app-base-input>
        <app-base-input id="lastName" name="lastName" placeholder="Last Name" [(ngModel)]="lastName" isFluid="true"
          mb="14px" (ngModelChange)="checkFormChanges()"></app-base-input>
      </div>
      <div class="row">
        <app-base-input id="email" name="email" type="email" placeholder="Email" [(ngModel)]="email" isFluid="true"
          mb="14px" (ngModelChange)="checkFormChanges()"></app-base-input>
      </div>
      <app-primary-btn *ngIf="isProfileDirty" (click)="saveProfile()" [isLoading]="isSavingProfile" gradient="true"
        mt="8px">Save</app-primary-btn>
    </form>

      <div class="setting-section">
        <app-section-label weight="700" size="14px" mb="14px">Your Jet Membership</app-section-label>

        <div class="membership-blocks">

          <app-membership-block *ngFor="let m of userProfile.memberships" [membership]="m"
            [canEdit]="canEditMembership(m)"
            (handleEdit)="onClickEditMembership($event)"></app-membership-block>

        </div>

      </div>

      <div class="setting-section">
        <div class="section-title-row">
          <div class="provider-heading">
            <app-section-label weight="700" size="14px" mb="0">Preferred Providers</app-section-label>
            <div class="provider-subline">Show flights from these providers first in results</div>
          </div>
          <app-spinner *ngIf="isSavingProviders" variant="btn-spinner"></app-spinner>
        </div>
        <button
          type="button"
          class="provider-select"
          [disabled]="isSavingProviders"
          aria-haspopup="dialog"
          (click)="openProviderTray()">
          <span>{{ preferredProviderSummary }}</span>
          <span class="select-chevron" aria-hidden="true"></span>
        </button>
      </div>

      <div class="setting-section" *ngIf="userProfile?.preferences">
        <app-section-label weight="700" size="14px" mb="14px">Your Preferences</app-section-label>

        <div class="pref-rows">

          <app-toggle-row *ngFor="let entry of userProfile.preferences | keyvalue" [setting]="entry.key"
            [description]="getSettingDescription(entry.key, 'preference')" settingVariant="preference"
            [checked]="entry.value.preference" [disabled]="isSavingPref" (settingChange)="onPreferenceChange($event)">
          </app-toggle-row>

        </div>
      </div>


      <div class="setting-section">
        <app-section-label weight="700" size="14px" mb="14px">Your Typical Flight</app-section-label>

        <div class="pref-rows">

          <app-toggle-row *ngFor="let entry of userProfile.preferences | keyvalue" [setting]="entry.key"
            [description]="getSettingDescription(entry.key, 'usage')" settingVariant="usage"
            [checked]="entry.value.usage" [disabled]="isSavingPref" (settingChange)="onPreferenceChange($event)">
          </app-toggle-row>

        </div>
      </div>

    </div>

    </div>

</app-page-wrapper>

<app-pop-tray
  *ngIf="showProviderTray"
  [header]="'Preferred Providers'"
  [description]="''"
  [showCloseButton]="true"
  [actions]="providerTrayActions">
  <div class="provider-tray-options" role="group" aria-label="Preferred providers">
    <button
      type="button"
      *ngFor="let p of providerOptions"
      class="provider-tray-option"
      [class.selected]="isDraftProviderSelected(p)"
      [disabled]="isSavingProviders"
      (click)="onProviderDraftToggle(p)">
      <span class="choice-check" aria-hidden="true">
        <span></span>
      </span>
      <span>{{ getProviderLabel(p) }}</span>
    </button>
  </div>
</app-pop-tray>
